import { DeleteModalProps } from '../../types/market-conquest/DeleteModalProps';
import { ExportModalProps } from '../../types/market-conquest/ExportModalProps';
import { NotesAndInsightsProps } from '../../types/market-conquest/NotesAndInsightsProps';
import { NotesCountMap } from '../../types/Note';
import {
  MarketConquestModalActions,
  MarketConquestModalActionsType,
} from './MarketConquestModalActions';

export type MarketConquestModalState = {
  isCustomerModalOpen: boolean;
  selectedId: string;
  isDeleteModalOpen: boolean;
  isExportModalOpen: boolean;
  deleteModalProps: DeleteModalProps;
  isNotesModalOpen: boolean;
  notesModalProps: NotesAndInsightsProps;
  notesCountMap: NotesCountMap[];
  exportModalProps: ExportModalProps;
  customerModalDealerId: string;
  isPrivateIncentiveAvailable: boolean;
};

export const initialMarketConquestModalState: MarketConquestModalState = {
  isCustomerModalOpen: false,
  selectedId: null,
  isNotesModalOpen: false,
  isDeleteModalOpen: false,
  isExportModalOpen: false,
  isPrivateIncentiveAvailable: false,
  customerModalDealerId: '',
  deleteModalProps: {
    customerName: '',
    leadId: '',
    dealerId: '',
  },
  notesModalProps: {
    fullName: '',
    leadId: '',
    legacyDealerId: '',
  },
  notesCountMap: [],
  exportModalProps: {
    resultsCount: 0,
    selectedLeadIds: [],
    isAllRowsSelected: false,
    toggleAllRowsValue: false,
  },
};

export const marketConquestModalReducer = (
  state: MarketConquestModalState = initialMarketConquestModalState,
  action: MarketConquestModalActions,
): MarketConquestModalState => {
  switch (action.type) {
    case MarketConquestModalActionsType.SET_CUSTOMER_MODAL_OPEN:
      return {
        ...state,
        isCustomerModalOpen: action.payload,
      };

    case MarketConquestModalActionsType.SET_SELECTED_ID:
      return {
        ...state,
        selectedId: action.payload,
      };

    case MarketConquestModalActionsType.SET_PRIVATE_INCENTIVE_AVAILABLE:
      return {
        ...state,
        isPrivateIncentiveAvailable: action.payload,
      };

    case MarketConquestModalActionsType.SET_DELETE_MODAL_PROPS:
      return {
        ...state,
        deleteModalProps: action.payload,
      };

    case MarketConquestModalActionsType.SET_DELETE_MODAL_OPEN:
      return {
        ...state,
        isDeleteModalOpen: action.payload,
      };

    case MarketConquestModalActionsType.SET_NOTES_MODAL_PROPS:
      return {
        ...state,
        notesModalProps: action.payload,
      };

    case MarketConquestModalActionsType.SET_NOTES_MODAL_OPEN:
      return {
        ...state,
        isNotesModalOpen: action.payload,
      };

    case MarketConquestModalActionsType.SET_UPDATED_NOTES_COUNT:
      const currentNotesCountForLead = state.notesCountMap?.find(
        (x) => x.leadId === action.payload.leadId,
      );
      currentNotesCountForLead.count = action.payload.count;
      return {
        ...state,
        notesCountMap: state.notesCountMap,
      };

    case MarketConquestModalActionsType.SET_NOTES_COUNT_MAP:
      return {
        ...state,
        notesCountMap: action.payload,
      };

    case MarketConquestModalActionsType.SET_EXPORT_MODAL_OPEN:
      return {
        ...state,
        isExportModalOpen: action.payload,
      };

    case MarketConquestModalActionsType.SET_EXPORT_MODAL_PROPS:
      return {
        ...state,
        exportModalProps: action.payload,
      };

    case MarketConquestModalActionsType.SET_CUSTOMER_MODAL_PROPS:
      return {
        ...state,
        customerModalDealerId: action.payload,
      };

    default:
      return state;
  }
};
